import { render, staticRenderFns } from "./SectionContactForm.vue?vue&type=template&id=9c50b684&"
import script from "./SectionContactForm.vue?vue&type=script&lang=js&"
export * from "./SectionContactForm.vue?vue&type=script&lang=js&"
import style0 from "./SectionContactForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormContactUs: require('/home/northbankcm/public_html/frontend/components/modules/FormContactUs.vue').default})
